import React from 'react';
import '../css/ServiceSection.css'; 
import { Helmet } from 'react-helmet';
const services = [
  {
    id: 1,
    imgSrc: '/images/keyword/20.jpg',
    title: 'Pune to Grishneshwar Cab Services',
    description: 'Experience a smooth and comfortable ride with S9 Travels on your journey from Pune to Grishneshwar. Enjoy a stress-free experience with our reliable and professional drivers, ensuring timely and safe travel.',
  },
  {
    id: 2,
    imgSrc: '/images/keyword/16.jpg',
    title: 'Mumbai to Pune Pickup & Drop Service',
    description: 'Travel in comfort and style with S9 Travels. Our Mumbai to Pune Pickup & Drop Service offers you a hassle-free journey with top-notch vehicles and a dedicated driver, perfect for smooth travel between the two cities.',
  },
  {
    id: 3,
    imgSrc: '/images/keyword/26.jpg',
    title: 'Pune to Shirdi Cab Services',
    description: 'Embark on a peaceful and convenient journey from Pune to Shirdi with S9 Travels. Our well-maintained vehicles and professional drivers will ensure that your spiritual journey is safe, comfortable, and memorable.',
  },
  {
    id: 4,
    imgSrc: '/images/keyword/22.jpg',
    title: 'Pune to Pandharpur Cab Services',
    description: 'Let S9 Travels take you from Pune to Pandharpur in comfort and style. Our professional drivers and premium vehicles offer timely and reliable services, ensuring that your pilgrimage is smooth and pleasant.',
  },
  {
    id: 5,
    imgSrc: '/images/keyword/78.jpg',
    title: 'Mumbai to Outstation Cab Services',
    description: 'S9 Travels offers you the best outstation cab services from Mumbai, with our well-maintained fleet of vehicles and experienced drivers ensuring that your trip is comfortable and stress-free.',
  },
  {
    id: 6,
    imgSrc: '/images/keyword/64.jpg',
    title: 'Pune to Prayagraj Cab',
    description: 'Travel with peace of mind on your journey from Pune to Prayagraj with S9 Travels. Our dedicated service ensures comfort and reliability, with a focus on safety and customer satisfaction for your spiritual journey.',
  },
  {
    id: 7,
    imgSrc: '/images/keyword/13.jpg',
    title: 'Pune to Mahabaleshwar Taxi Services',
    description: 'Travel with peace of mind on your journey from Pune to Mahabaleshwar with S9 Travels. Our dedicated service ensures comfort and reliability, with a focus on safety and customer satisfaction for your scenic getaway.',
  },
  {
    id: 8,
    imgSrc: '/images/keyword/5.jpg',
    title: 'Pune to Goa Taxi Services',
    description: 'Travel with peace of mind on your journey from Pune to Goa with S9 Travels. Our dedicated service ensures comfort and reliability, with a focus on safety and customer satisfaction for your relaxing beach vacation.',
  },
  {
    id: 9,
    imgSrc: '/images/keyword/80.jpg',
    title: 'Mumbai to 5 Jyotirlinga Darshan Cab',
    description: 'Travel with peace of mind on your journey from Mumbai to the 5 Jyotirlinga Darshan with S9 Travels. Our dedicated service ensures comfort and reliability, with a focus on safety and customer satisfaction for your spiritual pilgrimage to the sacred Jyotirlingas.',
  },
];


const ServiceSection = () => {
  return (
    <div>


<section className="page-title centred">
        <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
        <div className="auto-container">
          <div className="content-box">
            <h1>Our Services</h1>
          </div>
        </div>
      </section>

      <section id="about" className="jarallax text-light">
    <div className="center-y relative text-center">
        <div className="container">
            <div className="row ">
                <div className="col-md-12 text-center">
                    <h1 className='text-white'>Services</h1>
                </div>
                <div className="clearfix"></div>
            </div>
        </div>
    </div>
</section>
      <section className="service-section">
        <div className="container">
          <div className="row ">
            {services.map((service) => (
              <div key={service.id} className="col-12 col-md-6 col-lg-4">
                <div className="service-card">
                  <div className="service-image">
                    <img src={service.imgSrc} alt={service.title} className="img-fluid" />
                  </div>
                  <div className="service-content">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    {/* <button className="btn">Learn More</button> */}
                    {/* <button className="th-btn  " onClick={() => window.location.href = '/book-taxi'}>Learn More</button> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceSection;
